import _defaults from 'lodash/defaults'
import { RxCustomerAPI } from '@driftt/dapper'
import { parseBidirectionalPagedData } from 'utils/paging'

export const api = {
  fetch(id, options) {
    return RxCustomerAPI
      .get(`/end_users/${id}/timeline`, _defaults(options, {
        paginated: true,
        size: 20,
      }))
      .checkStatus()
      .retryWithBackoff()
      .map(parseBidirectionalPagedData())
  },
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/timeline/api.js